module.exports = {
	"account": {
		"CreateAccount": true,
		"CreateAffiliation": true,
		"CreateDataSource": true,
		"CreateImageContainer": true,
		"CreateEmailTemplate": true,
		"CreateFacebookTemplate": true,
		"CreateMailTemplate": true,
		"CreateOffer": true,
		"CreateSilo": true,
		"CreateTag": true,
		"ListAccounts": true,
		"ReadAccount": true,
		"ReadSettings": true,
		"ShareAudience": true,
		"ShareImageContainer": true,
		"ShareOffer": true,
		"ShareTemplate": true,
		"UpdateAccount": true,
		"UpdateSettings": true
	},
	"affiliation": {
		"ListAffiliations": true,
		"UpdateAffiliation": true
	},
	"audience": {
		"CreateAudience": true,
		"ReadAudience": true,
		"UpdateLISTAudience": true,
		"UpdateTMNAAudience": true,
		"UpdateCCDBAudience": true,
		"UpdateDMSAudience": true,
		"UpdateAudience": true,
		"DeleteLISTAudience": true,
		"DeleteTMNAAudience": true,
		"DeleteCCDBAudience": true,
		"DeleteDMSAudience": true,
		"DeleteAudience": true,
		"RequestAudience": true
	},
	"client": {},
	"datasource": {
		"ReadDataSource": true,
		"UpdateDataSource": true
	},
	"entity": {
		"ReadEntity": true,
		"UpdateEntity": true
	},
	"communication": {
		"ReadCommunication": true
	},
	"image": {
		"CreateEmailImage": true,
		"CreateFacebookImage": true,
		"CreateMailImage": true,
		"ListImageContainers": true,
		"ReadImageContainer": true,
		"ReadEmailImage": true,
		"ReadFacebookImage": true,
		"ReadMailImage": true,
		"UpdateEmailImage": true,
		"UpdateFacebookImage": true,
		"UpdateImageContainer": true,
		"UpdateMailImage": true
	},
	"import": {},
	"message": {
		"CreateMessage": true,
		"ReadMessage": true,
		"UpdateMessage": true,
		"DeleteMessage": true
	},
	"offer": {
		"ListOffers": true,
		"ReadOffer": true,
		"UpdateOffer": true,
		"DeleteOffer": true
	},
	"report": {},
	"silo": {
		"CreateImageContainer": true,
		"CreateEmailTemplate": true,
		"CreateFacebookTemplate": true,
		"CreateMailTemplate": true,
		"CreateOffer": true,
		"ListSilos": true,
		"ReadSettings": true,
		"ReadSilo": true,
		"ReadTags": true,
		"UpdateSettings": true,
		"UpdateSilo": true
	},
	"standardModel": {
		"ListStandardModel": true,
		"CreateStandardModel": true,
		"UpdateStandardModel": true,
		"DeleteStandardModel": true,
		"ReadStandardModel": true
	},
	"tag": {
		"ReadTag": true,
		"UpdateTag": true,
		"DeleteTag": true
	},
	"template": {
		"ListTemplates": true,
		"ReadTemplate": true,
		"ReadEmailTemplate": true,
		"ReadFacebookTemplate": true,
		"ReadMailTemplate": true,
		"UpdateEmailTemplate": true,
		"UpdateFacebookTemplate": true,
		"UpdateMailTemplate": true,
		"UpdateTemplate": true
	},
	"typedValue": {
		"ListTypedValues": true,
		"CreateTypedValue": true,
		"UpdateTypedValue": true,
		"DeleteTypedValue": true
	},
	"vinDecoding": {
		"ListVinDecoding": true,
		"CreateVinDecoding": true,
		"UpdateVinDecoding": true,
		"DeleteVinDecoding": true,
		"ReadVinDecoding": true
	},
	"ui": {
		"ViewTemplate": true,
		"EditTemplate": true,
		"CreateTemplate": true,
		"ShareTemplate": true,
		"ViewOffer": true,
		"EditOffer": true,
		"CreateOffer": true,
		"DeleteOffer": true,
		"ShareOffer": true,
		"ViewImage": true,
		"EditImage": true,
		"CreateImage": true,
		"ShareImage": true,
		"ViewMessage": true,
		"EditMessage": true,
		"CreateMessage": true,
		"ShareMessage": true,
		"ApproveMessage": true,
		"ViewOCPeReport": true,
		"ViewOnDemandReport": true,
		"ViewAccount": true,
		"EditAccount": true,
		"ViewSilo": true,
		"EditSilo": true,
		"ViewTag": true,
		"CreateTag": true,
		"EditTag": true,
		"DeleteTag": true,
		"ApplyTag": true,
		"UnapplyTag": true,
		"ViewSystem": true,
		"EditSystem": true,
		"ViewSwitcherActiveStatus": true,
		"ViewSwitcherSuspendedStatus": true,
		"ViewProofs": true,
		"ViewImportExportOffers": true,
		"ViewReportSettings": true,
		"EditReportSettings": true,
		"ViewDigitalReport": true,
		"ViewVinDecoding": true,
		"ManageVinDecoding": true,
		"ViewStandardModel": true,
		"ManageStandardModel": true,
		"ViewMonitoring": true
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/lib/actions.json
// module id = 292
// module chunks = 51